module.exports = __webpack_public_path__ + "static/media/bonusSpins_500_1000.0384e588.png";